import type { LoginInput } from '@lubehub/api';

/**
 * The same identifier rule the admin console uses: `@` means email, otherwise
 * the field is a phone number. Phone-only accounts must be able to sign in.
 */
export function loginFromIdentifier(identifier: string, password: string): LoginInput {
  const trimmed = identifier.trim();

  if (trimmed.includes('@')) {
    return { email: trimmed, password };
  }

  return { phone: trimmed, password };
}
